export default __webpack_public_path__ + "static/media/DCA_2222x1226.86a47ef0.jpg";